import { createAction } from '@reduxjs/toolkit';

import { SET_SIDEBAR_MENU, TOGGLE_SIDEBAR_MENU } from 'constants/redux-actions';

const toggleSidebarMenu = createAction(TOGGLE_SIDEBAR_MENU);
const setSidebarMenu = createAction(SET_SIDEBAR_MENU);

const sidebarMenuActions = {
  toggleSidebarMenu,
  setSidebarMenu,
};

export default sidebarMenuActions;
